import 'reflect-metadata'
import type { Configuration, WebpackPluginInstance } from 'webpack'
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 3,line: "require('../env')"});
require('../env')

/**
 * Creates a config for webpack for the backend
 * @param env the env
 * @param options the options
 */
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 10,line: "export function createConfig(env: 'production' | 'test' | 'development' = 'development', options: {"});
export function createConfig(env: 'production' | 'test' | 'development' = 'development', options: {
    useTypescript: boolean,
    shouldUseSourceMap: boolean,
    ForkTsCheckerWebpackPlugin: WebpackPluginInstance,
    disableEslintPlugin: boolean,
    emitErrorsAsWarnings: boolean
} = {
    useTypescript: true,
    shouldUseSourceMap: env === 'development' || process.env.GENERATE_SOURCEMAP !== 'false',
    ForkTsCheckerWebpackPlugin:	process.env.TSC_COMPILE_ON_ERROR === 'true'
        ? require('react-dev-utils/ForkTsCheckerWarningWebpackPlugin.js')
        : require('react-dev-utils/ForkTsCheckerWebpackPlugin.js'),
    disableEslintPlugin: process.env.DISABLE_ESLINT_PLUGIN === 'true',
    emitErrorsAsWarnings: process.env.ESLINT_NO_DEV_ERRORS === 'true'
}) {
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 25,line: "    const path = require('path') as typeof import('path')"});
    const path = require('path') as typeof import('path')
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 26,line: "    const webpack = require('webpack') as typeof import('webpack')"});
    const webpack = require('webpack') as typeof import('webpack')
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 27,line: "    const nodeExternals = require('webpack-node-externals') as typeof import('webpack-node-externals')"});
    const nodeExternals = require('webpack-node-externals') as typeof import('webpack-node-externals')
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 28,line: "    const pathsFunction = require('../paths') as typeof import('../paths')"});
    const pathsFunction = require('../paths') as typeof import('../paths')
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 29,line: "    const fs = require('fs') as typeof import('fs')"});
    const fs = require('fs') as typeof import('fs')
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 30,line: "    const existsSync = fs.existsSync"});
    const existsSync = fs.existsSync
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 31,line: "    options.useTypescript = options.useTypescript || fs.existsSync(pathsFunction.default().appTsConfig)"});
    options.useTypescript = options.useTypescript || fs.existsSync(pathsFunction.default().appTsConfig)
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 32,line: "    const EslintPlugin = require('eslint-webpack-plugin') as typeof import('eslint-webpack-plugin')"});
    const EslintPlugin = require('eslint-webpack-plugin') as typeof import('eslint-webpack-plugin')
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 33,line: "    const isEnvDevelopment = env === 'development'"});
    const isEnvDevelopment = env === 'development'
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 34,line: "    const isEnvProduction = env !== 'development'"});
    const isEnvProduction = env !== 'development'
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 35,line: "    const paths = pathsFunction.default()"});
    const paths = pathsFunction.default()
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 36,line: "    const config: Configuration = {"});
    const config: Configuration = {
        target: 'node',
        externals: [
            nodeExternals()
        ],
        node: {
            __filename: true,
            __dirname: true,
            global: true
        },
        context: path.resolve(__dirname, '../../'),
        output: {
            path: paths.backendBuild,
            // Add /* filename */ comments to generated require()s in the output.
            pathinfo: isEnvDevelopment,
            // There will be one main bundle, and one file per asynchronous chunk.
            // In development, it does not produce real files.
            filename: 'static/bundle.js',
            // There are also additional JS chunk files if you use code splitting.
            chunkFilename: 'static/[name].chunk.js',
            assetModuleFilename: 'static/media/[name].[hash][ext]',
            // Point sourcemap entries to original disk location (format as URL on Windows)
            devtoolModuleFilenameTemplate: isEnvProduction
                ? (info: { absoluteResourcePath: string; }) =>
                    path
                        .relative(paths.appBackend, info.absoluteResourcePath)
                        .replace(/\\/g, '/')
                : ((info: { absoluteResourcePath: string; }) => path.resolve(info.absoluteResourcePath).replace(/\\/g, '/')),
        },
        entry: [
            // pathsFunction.resolveApp('scripts/reflect-metadata'),
            paths.backendIndex
        ],
        module: {
            rules: [
                options.shouldUseSourceMap ? {
					enforce: 'pre' as 'pre',
					exclude: /@babel(?:\/|\\{1,2})runtime/,
					test: /\.(js|mjs|ts|css)$/,
					loader: require.resolve('source-map-loader'),
				} : {},
                {
                    oneOf: [
                        // Process any JS outside of the app with Babel.
						// Unlike the application JS, we only compile the standard ES features.
                        {
							test: /\.(js|mjs)$/,
							exclude: /@babel(?:\/|\\{1,2})runtime/,
							loader: require.resolve('babel-loader'),
							options: {
								babelrc: false,
								configFile: false,
								compact: false,
                                presets: [
                                    require.resolve('babel-preset-react-app/dependencies'),
                                    { helpers: true },
                                    ['@babel/preset-env', { targets: { node: 'current' } }],
                                    '@babel/preset-typescript'
                                ],
                                plugins: [
                                    ['@babel/plugin-proposal-decorators', { legacy: true }],  // Enable decorators
                                    ['@babel/plugin-proposal-class-properties', { loose: true }],  // Enable class properties
                                ],
								cacheDirectory: true,
								// See #6846 for context on why cacheCompression is disabled
								cacheCompression: false,

								// Babel sourcemaps are needed for debugging into node_modules
								// code.  Without the options below, debuggers like VSCode
								// show incorrect code and set breakpoints on the wrong lines.
								sourceMaps: options.shouldUseSourceMap,
								inputSourceMap: options.shouldUseSourceMap,
							},
						},
                        {
                            test: /\.(ts|tsx)$/,
                            exclude: /frontend|node_modules/,
                            loader: require.resolve('ts-loader')
                        },
                        // "file" loader makes sure those assets get served by WebpackDevServer.
						// When you `import` an asset, you get its (virtual) filename.
						// In production, they would get copied to the `build` folder.
						// This loader doesn't use a "test" so it will catch all modules
						// that fall through the other loaders.
                        {
							// Exclude `js` files to keep "css" loader working as it injects
							// its runtime that would otherwise be processed through "file" loader.
							// Also exclude `html` and `json` extensions so they get processed
							// by webpacks internal loaders.
							exclude: [/^$/, /\.(js|mjs|jsx|ts|tsx)$/, /\.html$/, /\.json$/],
							type: 'asset/resource',
						}
                    ],
                },
                {
                    test: /\.(ts|tsx)$/,
                    include: [
                        paths.appBackend,
                        paths.appShared,
                        paths.appConfig,
                        paths.appAssets
                    ],
                    exclude: /frontend|node_modules|scripts/,
                    loader: path.resolve(__dirname, 'loaders', 'executions', 'executions-loader.ts'),
                    options: {
                        node: true
                    }
                },
                {
                    use: [
                        {
                            loader: path.join(__dirname, 'loaders', 'import-aliases', 'import-aliases-loader.ts'),	
                        }
                    ],
                    test: /\.(ts|tsx)$/,
                    exclude: /node_modules/
                }
            ].filter(Boolean)
        },
        resolve: {
            roots: [
                pathsFunction.locateProject(process.cwd())!
            ],
            modules: [
                'node_modules',
                paths.appShared,
                paths.appConfig,
                paths.appAssets,
                paths.appNodeModules,
                paths.appBackend
            ],
            extensions: pathsFunction.moduleFileExtensions.map((v) => `.${v}`),
            alias: {
                'backend': paths.appBackend,
				'shared': paths.appShared,
				'assets': paths.appAssets,
				'config': paths.appConfig,
				scripts: paths.appScripts
            }
        },
        experiments: {
			topLevelAwait: true, // Enable top-level await
		},
        plugins: [
            !options.disableEslintPlugin &&
            new webpack.HotModuleReplacementPlugin()
        ],
        bail: isEnvProduction,
		devtool: isEnvProduction
            ? options.shouldUseSourceMap
                ? 'source-map'
                : false
            : isEnvDevelopment && 'cheap-module-source-map',
        mode: isEnvProduction ? 'production' : 'development'
    }
    global.executions.addLine({className: "<global>",functionName: "createConfig",hierarchy: ["/config/webpack/webpack.backend.config.ts", "<global>", "createConfig"],fileName: "/config/webpack/webpack.backend.config.ts",childLine: 191,line: "    return config"});
    return config
}

export default createConfig(process.env.NODE_ENV as any)